<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :ripple="true"> پیش نمایش </v-tab>
          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 10px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <component :is="cardTexts.designSettings?.theme" v-model="cardTexts" :orders.sync="cardTexts.orders" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <v-col cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <!-- مرحله اول -->
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات شبکه های اجتماعی</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام شبکه اجتماعی"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="نام شبکه اجتماعی"
                  />
                </div>

              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12 mt-4">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="step1()"
                />
              </div>
            </v-stepper-content>

            <!-- مرحله دوم -->
            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <list-expansion
                  flat
                  icon="pencil-ruler"
                  single
                  :title="$t('select_template_design')"
                >

                  <template v-slot:content>
                  <theme-layout-selector v-model="cardTexts.designSettings" />
                  </template>
                </list-expansion>

              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                flat
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>

        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { getLanguageCookie } from "../../../core/plugins/TitleRibbon/utils/languageCookie.js";
import HelpInfo from "../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "@/view/pages/qrland/components/qrMaker.vue";
import SocialMobile from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile.vue";
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import NextBtn from "@/view/content/fragments/nextBtn.vue";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import { Bus } from "@/main";
import socialMobile1_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile1_ok.vue";
import socialMobile2_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile2_ok.vue";
import socialMobile3_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile3_ok.vue";
import socialMobile4_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile4_ok.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField.vue";
import ThemeLayoutSelector from "../otherQrTypes/socialMedia/ThemeLayoutSelector.vue";

export default {
  name: "indexSocialModel",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    QrCodeMake,
    NextBtn,
    ListExpansion,
    SocialMobile,
    QrMaker,
    ThemeLayoutSelector,
    socialMobile1_ok,
    socialMobile2_ok,
    socialMobile3_ok,
    socialMobile4_ok

  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "indexSocial",
      e6: 1,
      qrShow: 1,
      svgMade: "",
      createdId: null,
      createdDomain: null,
      dtUrl: null,
      domainId: null,
      showDialog: false,
      loading: false,
      errors: {},
      info: null,
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      cardTexts: {
        orders: [
              { name: 'banner' },
              { name: 'profile' },
              { name: 'about' },
              { name: 'socialMedia' },
            ],
        designSettings: {
              theme: "socialMobile4_ok",
              layout: "SocialListGrouped"
            },
        visitName: "شبکه های اجتماعی",
        banner: {
          gallery: [
            {
              name: "بنر",
              images: [
                {
                  name: "بنر ۱",
                  title: "images1",
                  url: "",
                  description: "کیوآرلند مدرنترین روش تبلیغات با اقتصادی ترین هزینه ممکن!",
                  link: "",
                },
                {
                  name: "بنر ۲",
                  title: "images2",
                  url: "",
                  description: "با ترمینال تبلیغات، کسب‌وکار خود را متمایز کنید!",
                  link: "",
                },
              ],
            },
          ],
        },
        photo: {
          profile: "",
          transition: "scale",
          hasWelcome: false,
          showWelcome: false,
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
          headBackground: "",

        },
        VideoGallery: {
          title: "گالری ویدئو",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
          grid: false,
          secondPosition: true,
        },
        video_gallery: [
          {
            name: "گالری",
            images: [
              {
                title: "",
                url: "https://www.aparat.com/video/video/embed/videohash/VdKgy/vt/frame",
                description:
                  "تو این ویدیو به بررسی گوشی اقتصادی جی پلاس Q20 پرداختیم که مشابه گوشی آیفون 13 است !\n" +
                  "یکی از مقرون به صرفه ترین گوشی ایرانی ، قطعا گوشی اقتصادی جی پلاس Q20 هست که ظاهر شبیه Iphone 13 داره !\n",
                link: "",
              },
            ],
          },
        ],
        buttonName: "راه های ارتباطی من",
        organizationName: "ترمینال تبلیغات",
        subtitle: "در کمتر از چند دقیقه سازمان خودرا به مخاطب معرفی کنید!",
        website: "",
        aboutUs:
          "ترمینال تبلیغات\n" +
          "\n" +
          "تنها سامانه جامع بررسی و مدیریت تبلیغات آنلاین\n" +
          "\n" +
          "سامانه ترمینال تبلیغات بزرگترین و مهمترین سرمایه خود را مشتریان و کاربران وفادار می داند.",
        PicSelector: {
          title: "",
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
          grid: true,
        },
        baseInfo: {
          sectionColor: {
            backGround: "linear-gradient(to right , #1e3c72, #2a5298)",
            text: "#ffffff",
          },
          slider: false,
          grid: false,
        },
        socialMediaIcons: {
          sectionColor: {
            backGround: "linear-gradient(to right , #345998, #284273)",
            text: "#ffffff",
          },
          slider: false,
          grid: false,
        },
        socialMedia: {},
      },

      specialInfo: [
        {
          name: "bannerSelector",
          value: "",
          title: "آپلود عکس",
          icon: "image",
          model: "banner",
        },
        {
          name: "baseInfo",
          value: "",
          title: "اطلاعات",
          icon: "account-outline",
        },
        {
          name: "imageUploader",
          value: "",
          title: "آپلود لوگو",
          icon: "image",
          model: "photo",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
      ],
      qrSvgDataUrl: "",
    };
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },
  mounted() {
    const savedLanguage = "fa";
    this.$i18n.locale = savedLanguage;
     this.cardTexts.banner.gallery[0].images[0].url = this.defaultroboatUrl;
    this.cardTexts.banner.gallery[0].images[1].url = this.defaultroboatUrl;
    this.cardTexts.photo.profile =
      this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png";
    this.cardTexts.website = this.$coreqrApi;
    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });
  },

  computed: {
    defaultroboatUrl() {
      return this.$cdnUrl + "/upload/64b1535578ce0.webp";
    },
    defaultProfileImage() {
      return (
        this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png"
      );
    },
    defaultWebsite() {
      return this.$coreqrApi || "https://qr.terminalads.com";
    },
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  methods: {
    step1(){
      if (!this.cardTexts.visitName?.trim()) {
      this.$toast.error("لطفاً نام شبکه اجتماعی را وارد نمایید.");
      return;
      }
      this.e6=2;

    },
    markQr(final = false) {

      this.loading = true;
      let obj = {
        type: "SocialMedia",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: this.cardTexts?.designSettings?.theme || "socialMobile4_ok",
          data: this.cardTexts,
        }),
        qr: {
          section: "#link",
          link: "https://qr2.in/",
          backcolor: "#ffffff",
          frontcolor: "#000000",
          gradient_color: "#000000",
          marker_out_color: "#000000",
          marker_in_color: "#000000",
          marker_top_right_outline: "#000000",
          marker_top_right_center: "#000000",
          marker_bottom_left_outline: "#000000",
          marker_bottom_left_center: "#000000",
          framecolor: "#000000",
          optionlogo: "none",
          "logo-size": 100,
          marker: "default",
          marker_in: "default",
          outer_frame: "none",
          framelabel: "SCAN ME",
          label_font: "AbrilFatface.svg",
          "label-text-size": 100,
          size: "248",
          level: "M",
        },
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("qr/template", {
          qr: obj,
          type: "SocialMedia",
          title: this.cardTexts.visitName,
        })
        .then(({ data }) => {
          this.loading = false;
          this.info = data.data;
          this.qrShow = 0;
          this.$toast.success("مدل شبکه اجتماعی شما با موفقیت ساخته شد.");
          this.$router.replace({ name: "modelsList" });

        })
        .catch((error) => {
          const response = error.response;
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

        })
        .finally(() => {
          this.loading = false;
        });
    },

  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
